module.exports = __webpack_public_path__ + "img/NDZ_Header_Thorn_Wheel.238c752d.svg";